import { render, staticRenderFns } from "./ReferenceLogItem.vue?vue&type=template&id=3cc13534&scoped=true&"
import script from "./ReferenceLogItem.vue?vue&type=script&lang=js&"
export * from "./ReferenceLogItem.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceLogItem.vue?vue&type=style&index=0&id=3cc13534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc13534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VItem,VListItem})
